export const REPORTS_NO_RESULT_TITLE = 'No reports to show';
export const REPORTS_DETAILS_NO_RESULT_TITLE = 'No report details to show';
export const REPORTS_NO_RESULT_SUBTITLE = 'Change your filters and try again.';